import React, {Component} from 'react';
import WorkerShiftRecordCol from './WorkerShiftRecordCol';

class WorkerScheduleRow extends Component {
  render() {
    let {dispatch, date, mornShift, aftnShift, otShift, siteList, positionList, user, sessionConfig} = this.props;
    return (
      <tr>
        <td>
          {date.format('DD')}
        </td>

        <WorkerShiftRecordCol
          siteList={siteList}
          date={date}
          record={mornShift}
          sid={0}
          positionList={positionList}
          user={user}
          sessionConfig={sessionConfig}
          dispatch={dispatch} />

        <WorkerShiftRecordCol
          siteList={siteList}
          date={date}
          record={aftnShift}
          sid={1}
          positionList={positionList}
          user={user}
          sessionConfig={sessionConfig}
          dispatch={dispatch} />

        <WorkerShiftRecordCol
          siteList={siteList}
          date={date}
          record={otShift}
          sid={2}
          positionList={positionList}
          user={user}
          sessionConfig={sessionConfig}
          dispatch={dispatch} />
      </tr>
    )
  }
}

export default WorkerScheduleRow;



// WEBPACK FOOTER //
// ./src/components/Schedule/WorkerScheduleRow.js